module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/lunarts-avatar-25917117e6428386e71341b7b423590a.jpg";